module.exports = __webpack_public_path__ + "static/media/YM20_2.4e754bc6.jpg";